<div class="fiche-preview-container">
  <!-- Navigation et contrôles -->
  <div class="controls-header"
    style="background: #f5f5f5; padding: 10px; border-bottom: 1px solid #ddd; display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
    <button (click)="previousPage()" [disabled]="currentPage === 1"
      style="padding: 8px 16px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;"
      [style.background]="currentPage === 1 ? '#ccc' : '#007bff'"
      [style.cursor]="currentPage === 1 ? 'not-allowed' : 'pointer'">
      ← Page Précédente
    </button>

    <div style="display: flex; align-items: center; gap: 20px;">
      <span style="font-weight: bold;">Page {{currentPage}} sur {{totalPages}}</span>
      <button (click)="printFiche()"
        style="padding: 8px 16px; background: #28a745; color: white; border: none; border-radius: 4px; cursor: pointer;">
        🖨️ Imprimer
      </button>
      <button (click)="downloadFiche()"
        style="padding: 8px 16px; background: #17a2b8; color: white; border: none; border-radius: 4px; cursor: pointer;">
        📄 Télécharger
      </button>
      <button (click)="closePreview()"
        style="padding: 8px 16px; background: #dc3545; color: white; border: none; border-radius: 4px; cursor: pointer;">
        ✕ Fermer
      </button>
    </div>

    <button (click)="nextPage()" [disabled]="currentPage === totalPages"
      style="padding: 8px 16px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;"
      [style.background]="currentPage === totalPages ? '#ccc' : '#007bff'"
      [style.cursor]="currentPage === totalPages ? 'not-allowed' : 'pointer'">
      Page Suivante →
    </button>
  </div>

  <!-- Contenu de la fiche -->
  <div class="fiche-content"
    style="background: white; box-shadow: 0 0 20px rgba(0,0,0,0.1); margin: 0 auto; max-width: 800px;">

    <!-- Page 1 -->
    <div *ngIf="currentPage === 1" class="page-content" style="min-height: 800px; padding: 0;" [innerHTML]="page1Html">
    </div>

    <!-- Page 2 -->
    <div *ngIf="currentPage === 2" class="page-content" style="min-height: 800px; padding: 0;" [innerHTML]="page2Html">
    </div>

  </div>
</div>